<script>
    import { onMount } from "svelte";
    import { createEventDispatcher } from 'svelte';
    import { Authentication } from '../stores'
    
    const dispatch = createEventDispatcher();

    export let customer;

    let sellOffStep = 0;
    let value;
    let shown = false;
    let nextButtonDisabled = false;
    let authenthicationData = '';
    let cheeseDropDown = [{ id: "0", text: "Loading ..." }];
    let cheeseDropDownSelected;
    let loadedCheese = null;

    onMount(async function () {

    });

    async function loadCheese() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/OrderedCheese/' + customer.id;

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        var arrayLength = data.length;
        if(arrayLength > 0) {
            cheeseDropDown = [];
            for (var i = 0; i < arrayLength; i++) {
                cheeseDropDown.push({id: data[i].id, text1: data[i].location_Name + ' Etage: ' + data[i].locationLevel + ' Pos.: ' + data[i].locationLevelPosition + ' (' + data[i].cheeseType_Name + ')', text2: 'Erstellung: ' + formatDate(data[i].creationDate)});
            }
        }
    }

    async function loadSelectedCheese() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/Cheese/' + cheeseDropDownSelected.id;

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();
        console.log('Ausgewählter Käse: ' + data[0].remark);

        if(data.length === 1) {
            loadedCheese = data[0];
        }
        else {
            loadedCheese = null;
        }
    }

    export function show() {
        loadCheese();

        sellOffStep = 0;
        nextButtonDisabled = true;
        cheeseDropDownSelected = '';
        shown = true;
    }
    function hide() {
        shown = false;
    }

    let onChange = () => {};

    function _onNextClick() {
        sellOffStep += 1;
    }

    async function _onOkay() {
        if(loadedCheese === null) {
            return;
        }

        await Authentication.subscribe((data) => authenthicationData = data);

        let method = 'PUT';

        loadedCheese.sold = true;

        const response = await fetch(
            'MYURL/Cheese',
            {
                method: method,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
                body: JSON.stringify(
                    loadedCheese
                )
            }
        );
        const data = await response.json();

        dispatch('accepted', {
            
        });

        _onCancel();
    }
    
    function _onCancel() {
        hide();
    }

    async function _cheeseSelected() {
        // Now load the selected cheese data
        await loadSelectedCheese();

        nextButtonDisabled = false;
    }
    
    function formatDate(date) {
        let the_date = new Date(date)
        let yyyy = the_date.getFullYear();
        let mm = the_date.getMonth() + 1; // Months start at 0!
        let dd = the_date.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        return dd + '/' + mm + '/' + yyyy;
    }

    $: onChange(value)
</script>

<svelte:window on:keydown={(e) => {
    if(e.keyCode == 27) {
        hide();
    }
}} />
{#if shown}
    <div class="orderMgt">
        <div class="modal">
            <span class="close" on:click={() => hide()}>&times</span>
            
            {#if sellOffStep === 0}
            <h2>Käse auswählen (Ausbuchen)</h2>

            <select class="dropdown" bind:value={cheeseDropDownSelected} on:change="{() => _cheeseSelected()}">
                {#each cheeseDropDown as cheeseDropDownItem}
                <option class="dropdown" value={cheeseDropDownItem}>
                    <p>{cheeseDropDownItem.text1}</p>
                    <p>{cheeseDropDownItem.text2}</p>
                </option>
                {/each}
            </select>
            {/if}
            {#if sellOffStep === 1}
            <h2>Kommentar/Bemerkung</h2>
            <textarea class="textboxMultiLine" bind:value={loadedCheese.remark} />
            {/if}
            {#if sellOffStep === 2}
            <h2>Verkaufsdaten</h2>
            <h3>Verkaufsgewicht</h3>
            <input class="textbox" type=number step=0.01 bind:value={loadedCheese.soldWeight} />
            <h3>Preis</h3>
            <input class="textbox" type=number step=0.01 bind:value={loadedCheese.price} />
            {/if}
            
            <div>
                <div class="buttons">
                    {#if sellOffStep < 2}
                        <button disabled={nextButtonDisabled} on:click={() => _onNextClick()}>
                            Weiter
                        </button>
                    {:else}
                        <button on:click={() => _onOkay()}>
                            Speichern
                        </button>
                    {/if}
                    <button on:click={() => _onCancel()}>
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}


<style>

    .dropdown {
        margin-top: -10px;
        min-width: 500px;
    }

    .textbox {
        padding-top: -10px;
        margin-top: -10px;
        min-width: 500px;
    }
    
    .textboxMultiLine {
        padding-top: -10px;
        margin-top: -10px;
        min-width: 500px;
        min-height: 100px;
    }

    .buttons {
        float: right;
    }

	.orderMgt {
	  background: rgb(0, 0, 0);
	  background: rgba(0, 0, 0, 0.6);
      position: fixed;
      width: 88%;
      height: 100%;
      top: 0;
      left: 0;

	  padding: 3rem 7.5rem;
	  display: flex;
	  flex-direction: column;
	}

    .modal {
        background-color: white;
        max-width: 80vw;
        padding: 1em;
        margin: -30px auto;
    }

    .close {
        cursor: pointer;
        float: right;
    }
    .close:hover {
        font-weight: bold;
    }
  
    @media only screen and (max-width: 767px) {
        .orderMgt {
            background: rgb(0, 0, 0);
            background: rgba(0, 0, 0, 0.6);
            position: fixed;
            width: 98%;
            height: 100%;
            top: 0;
            left: 0;

            padding: 3rem 1%;
            display: flex;
            flex-direction: column;
        }

        .dropdown {
            margin-top: -10px;
            min-width: 100%;
            max-width: 100%;
        }
        
        .textbox {
            padding-top: -10px;
            margin-top: -10px;
            min-width: 320px;
        }
        
        .textboxMultiLine {
            padding-top: -10px;
            margin-top: -10px;
            min-width: 320px;
            min-height: 100px;
        }
    }
</style>